export interface AssaysViewModalToolbarSummaryModelState {
    display: boolean
}
export const initialAssaysViewModalToolbarSummaryModelState =
    (): AssaysViewModalToolbarSummaryModelState => ({
        display: true
    })
